import { isMobile } from '../../../src/js/utils/is-mobile';

const ELSASlider = function () {
  $('.js-package-slider').slick({
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable: true,
    mobileFirst: true,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 767,
        settings: 'unslick',
      },
    ],
  });

  if ($('.elsa-pro__slides').length) {
    $('.elsa-pro__slides').slick({
      autoplay: true,
      autoplaySpeed: 5000,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      arrows: false,
      dots: false,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            dots: true,
          },
        },
      ],
    });

    $('.elsa-pro__nav li').on('click', function () {
      const slideIndex = $(this).data('slide');
      $('.elsa-pro__nav li').removeClass('active');
      $('.elsa-pro__slides').slick('slickGoTo', slideIndex);
      $(this).addClass('active');
    });

    $('.elsa-pro__slides').on('afterChange', function (event, slick, currentSlide) {
      $('.elsa-pro__nav li').removeClass('active');
      const targetItem = $('.elsa-pro__nav li').eq(currentSlide);
      const container = $('.elsa-pro__nav');
      targetItem.addClass('active');

      if (isMobile()) {
        const scrollLeft = targetItem[0].offsetLeft;
        container[0].scrollTo({
          top: 0,
          left: scrollLeft,
          behavior: 'smooth'
        });
      }
    });
  }

  if ($('.elsa-ai__slider').length) {
    $('.elsa-ai__slider').each(function (idx, el) {
      const $slider = $(el);

      $slider.slick({
        autoplay: true,
        autoplaySpeed: 5000,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        arrows: false,
        dots: false,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              dots: true,
            },
          },
        ],
      });

      // Match nav by index in case there are multiple slider/nav pairs
      const $nav = $('.elsa-ai__nav').eq(idx);
      if (!$nav || !$nav.length) return;

      $nav.find('li').on('click', function () {
        const slideIndex = $(this).data('slide');
        $nav.find('li').removeClass('active');
        $slider.slick('slickGoTo', slideIndex);
        $(this).addClass('active');
      });

      $slider.on('afterChange', function (event, slick, currentSlide) {
        $nav.find('li').removeClass('active');
        const targetItem = $nav.find('li').eq(currentSlide);
        targetItem.addClass('active');

        if (isMobile()) {
          const scrollLeft = targetItem[0] && targetItem[0].offsetLeft;
          if (typeof scrollLeft !== 'undefined') {
            $nav[0].scrollTo({
              top: 0,
              left: scrollLeft,
              behavior: 'smooth',
            });
          }
        }
      });
    });
  }

  if ($('.elsa-sa__slider').length) {
    $('.elsa-sa__slider').slick({
      autoplay: true,
      autoplaySpeed: 5000,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      arrows: false,
      dots: false,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            dots: true,
          },
        },
      ],
    });

    $('.elsa-sa__nav li').on('click', function () {
      const slideIndex = $(this).data('slide');
      $('.elsa-sa__nav li').removeClass('active');
      $('.elsa-sa__slider').slick('slickGoTo', slideIndex);
      $(this).addClass('active');
    });

    $('.elsa-sa__slider').on('afterChange', function (event, slick, currentSlide) {
      $('.elsa-sa__nav li').removeClass('active');
      const targetItem = $('.elsa-sa__nav li').eq(currentSlide);
      const container = $('.elsa-sa__nav');
      targetItem.addClass('active');

      if (isMobile()) {
        const scrollLeft = targetItem[0].offsetLeft;
        container[0].scrollTo({
          top: 0,
          left: scrollLeft,
          behavior: 'smooth'
        });
      }
    });
  }

  if ($('.elsa-certificate__slider').length) {
    $('.elsa-certificate__slider').slick({
      autoplay: true,
      autoplaySpeed: 5000,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      fade: true,
      arrows: false,
      dots: false,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            dots: true,
          },
        },
      ],
    });

    $('.elsa-certificate__nav li').on('click', function () {
      const slideIndex = $(this).data('slide');
      $('.elsa-certificate__nav li').removeClass('active');
      $('.elsa-certificate__slider').slick('slickGoTo', slideIndex);
      $(this).addClass('active');
    });

    $('.elsa-certificate__slider').on('afterChange', function (event, slick, currentSlide) {
      $('.elsa-certificate__nav li').removeClass('active');
      const targetItem = $('.elsa-certificate__nav li').eq(currentSlide);
      const container = $('.elsa-certificate__nav');
      targetItem.addClass('active');

      if (isMobile()) {
        const scrollLeft = targetItem[0].offsetLeft;
        container[0].scrollTo({
          top: 0,
          left: scrollLeft,
          behavior: 'smooth'
        });
      }
    });
  }
};

export default ELSASlider;
